import { canUseDOM } from './dom';
var animationEvent = {
  supported: false,
  name: null
};
var transitionEvent = {
  supported: false,
  name: null
};

if (canUseDOM) {
  if (typeof AnimationEvent !== 'undefined') {
    animationEvent.supported = true;
    animationEvent.name = 'animationend';
  } else if (typeof WebKitAnimationEvent !== 'undefined') {
    animationEvent.supported = true;
    animationEvent.name = 'webkitAnimationEnd';
  }

  if (typeof TransitionEvent !== 'undefined') {
    transitionEvent.supported = true;
    transitionEvent.name = 'transitionend';
  } else if (typeof WebKitTransitionEvent !== 'undefined') {
    transitionEvent.supported = true;
    transitionEvent.name = 'webkitTransitionEnd';
  }
}

export { animationEvent, transitionEvent };
//# sourceMappingURL=supportEvents.js.map